(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminCustomerAccountDialogController', NasracAdminCustomerAccountDialogController);

    NasracAdminCustomerAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance','$state', 'entity', 'NasracAdminCustomerAccount'];

    function NasracAdminCustomerAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance,$state, entity, NasracAdminCustomerAccount) {
        var vm = this;

        vm.nasracAdminCustomerAccount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.isReadOnly = $state.$current.data.isReadOnly;
            $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nasracAdminCustomerAccount.id !== null) {
                NasracAdminCustomerAccount.update(vm.nasracAdminCustomerAccount, onSaveSuccess, onSaveError);
            } else {
                NasracAdminCustomerAccount.save(vm.nasracAdminCustomerAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracAdminCustomerAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.launchDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
